var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSchedulesBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114 75"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.534 10.059h59.977c1.726 0 3.125 1.4 3.125 3.125V71.07c0 1.726-1.4 3.125-3.125 3.125H49.534a3.125 3.125 0 01-3.125-3.125V13.184c0-1.726 1.4-3.125 3.125-3.125z",
    fill: "#82B1E8",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.572 8.296H48.623c-1.098 0-2.15.433-2.927 1.204a4.097 4.097 0 00-1.212 2.908V68.32c0 1.09.436 2.136 1.212 2.908a4.154 4.154 0 002.927 1.203h57.95c1.098 0 2.15-.433 2.926-1.204a4.097 4.097 0 001.212-2.907V12.406c0-2.27-1.854-4.11-4.14-4.11z",
    stroke: "#82B1E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#82B1E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M52.761 56.809h8.279v8.222H52.76zM52.761 42.83h8.279v8.223H52.76z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#82B1E8",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M52.761 28.028h8.279v8.223H52.76z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#82B1E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M66.835 56.809h8.278v8.222h-8.278zM66.835 42.83h8.278v8.223h-8.278zM66.835 28.028h8.278v8.223h-8.278zM80.908 56.809h8.278v8.222h-8.278zM80.908 42.83h8.278v8.223h-8.278zM80.908 28.028h8.278v8.223h-8.278zM94.982 42.83h8.278v8.223h-8.278zM94.982 28.028h8.278v8.223h-8.278z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#82B1E8",
    strokeWidth: 2,
    fill: "#0E1932",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M86.329 1.484h10.393v13.674H86.33z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#82B1E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M84.777 15.15h13.496"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#82B1E8",
    strokeWidth: 2,
    fill: "#0E1932",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M58.474 1.484h10.394v13.674H58.474z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#82B1E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M56.923 15.15H70.42M44.484 19.402h66.228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.968 30.99l-28.36.055c-7.375.014-13.424 6.045-13.412 13.37.015 7.326 6.086 13.334 13.463 13.322l28.36-.054c7.374-.014 13.423-6.045 13.411-13.37-.014-7.329-6.087-13.337-13.462-13.322z",
    fill: "#0E1932",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.418 32.463l-28.36.054c-7.375.014-13.424 6.045-13.412 13.37.012 7.326 6.086 13.334 13.463 13.322l28.36-.054c7.375-.014 13.423-6.045 13.411-13.37-.012-7.326-6.086-13.337-13.462-13.322zm-.946 22.526c-5.106.01-9.254-4.095-9.263-9.167-.01-5.072 4.121-9.192 9.228-9.202 5.106-.01 9.254 4.094 9.264 9.166a9.146 9.146 0 01-2.693 6.502 9.272 9.272 0 01-6.536 2.7z",
    fill: "#82B1E8",
    fillRule: "nonzero",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.02 53.515c-5.106.01-9.253-4.094-9.263-9.166-.01-5.072 4.122-9.192 9.228-9.202 5.107-.01 9.255 4.094 9.265 9.166a9.146 9.146 0 01-2.694 6.502 9.272 9.272 0 01-6.535 2.7h0z",
    stroke: "#82B1E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.968 30.99l-28.36.055c-7.375.014-13.424 6.045-13.412 13.37h0c.015 7.326 6.086 13.334 13.463 13.322l28.36-.054c7.374-.014 13.423-6.045 13.411-13.37h0c-.014-7.329-6.087-13.337-13.462-13.322z",
    stroke: "#82B1E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.724 47.114a2.31 2.31 0 01-.918-.986 3.67 3.67 0 010-3.004c.2-.411.52-.754.918-.982a3.046 3.046 0 012.815 0c.396.23.715.572.914.982a3.67 3.67 0 010 3.004c-.2.412-.52.755-.918.986-.877.46-1.926.46-2.803 0h-.008zm2.599-.986c.286-.352.429-.853.429-1.504 0-.65-.143-1.153-.43-1.506a1.633 1.633 0 00-2.39 0c-.286.347-.429.847-.429 1.5 0 .652.143 1.153.43 1.503a1.625 1.625 0 002.39 0v.007zM21.72 41.866h.949v5.523h-.764l-2.976-3.855v3.855h-.945v-5.523h.755l2.976 3.846z",
    fill: "#82B1E8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D2E6EF",
    strokeWidth: 0.781,
    fill: "#0E1932",
    fillRule: "nonzero",
    d: "M51.287 55.81l-8.64-7.539v11.43l3.148-2.285 2.23 4.981 1.73-.765-2.231-4.981z"
  }))));
}

export default __webpack_public_path__ + "static/schedules-blue.4c84a1c6.svg";
export { SvgSchedulesBlue as ReactComponent };